export default "__VITE_ASSET__lUGm5dS___"